import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let CompanyConnectApi = class CompanyConnectApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    /**
     * 获取公司Connect权限列表
     */
    async getConnectPermissions(params) {
        const { company_id, ...queryParams } = params;
        return this.http.get({
            url: this.urls.getConnectPermissions,
            params: {
                company_id,
                ...queryParams,
            },
        });
    }
    /**
     * 获取公司Connect使用明细
     */
    async getUsageDetails(params, queryParams) {
        return this.http.post({
            url: this.urls.getUsageDetails,
            data: params,
            params: queryParams,
        });
    }
    /**
     * 导出公司Connect使用明细
     */
    async downloadUsageDetails(params) {
        return this.http.request({
            url: this.urls.downloadUsageDetails,
            method: 'post',
            data: params,
            responseType: 'blob',
            rawResponse: true,
        });
    }
    /**
     * 获取成功调用排名
     */
    async getRankingApiCall(params, queryParams) {
        return this.http.post({
            url: this.urls.getRankingApiCall,
            data: params,
            params: queryParams,
        });
    }
    /**
     * 获取账户余额
     */
    async getAccountBalance(companyId) {
        return this.http.get({
            url: this.urls.getAccountBalance,
            params: {
                company_id: companyId,
            },
        });
    }
    /**
     * 获取付费模式列表（Prepaid Model）
     */
    async getPrepaidCategories(companyId) {
        return this.http.get({
            url: this.urls.getPrepaidCategories,
            params: {
                company_id: companyId,
            },
        });
    }
    /**
     * 获取计次模式列表（Fixed-Quota Plan）
     */
    async getFixedQuotaCombos(companyId) {
        return this.http.get({
            url: this.urls.getFixedQuotaCombos,
            params: {
                company_id: companyId,
            },
        });
    }
};
CompanyConnectApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyConnectUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyConnectApi);
export { CompanyConnectApi };
